import { render } from "./CustomChart.vue?vue&type=template&id=6ee50481&scoped=true"
import script from "./CustomChart.vue?vue&type=script&lang=js"
export * from "./CustomChart.vue?vue&type=script&lang=js"

import "./CustomChart.vue?vue&type=style&index=0&id=6ee50481&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee50481"]])

export default __exports__